import React, { FC } from "react";
import { ReturnReasonsRaw } from "./ReturnReasonsRaw";
import { CommonEvent } from "@narvar/nth-kit-returns-headless";
import { ReturnReasonsPayload, ReturnReasonsProps } from "./types";
import useCurrencyConfig from "../ReviewSummary/hooks/useCurrencyConfig";

export const ReturnReasons: FC<ReturnReasonsProps> = ({
  onNext,
  onBack,
  onChange,
  onSubmit,
  onClose,
  ...props
}) => {
  const { locale, includeCurrency } = useCurrencyConfig();
  const handleChange: CommonEvent<ReturnReasonsPayload> = (e) => {
    onChange?.(e);
  };

  const handleNext: CommonEvent<ReturnReasonsPayload> = (e) => {
    onNext?.(e);
  };

  const handleBack: CommonEvent<ReturnReasonsPayload> = (e) => {
    onBack?.(e);
  };

  const handleSubmit: CommonEvent<ReturnReasonsPayload> = (e) => {
    onSubmit?.(e);
  };

  const handleClose: CommonEvent<ReturnReasonsPayload> = (e) => {
    onClose?.(e);
  };

  return (
    <ReturnReasonsRaw
      onNext={handleNext}
      onBack={handleBack}
      onChange={handleChange}
      onSubmit={handleSubmit}
      onClose={handleClose}
      locale={locale}
      includeCurrency={includeCurrency}
      {...props}
    />
  );
};

export { ReturnReasonsRaw };
